import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Drawer,
  withStyles,
  IconButton,
  Typography,
  withWidth,
  isWidthUp,
  Toolbar
} from "@material-ui/core";
import Divider from '@material-ui/core/Divider';
import CloseIcon from "@material-ui/icons/Close";
import styled from 'styled-components';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

const StylesList = styled(List)`
min-width: 405px;
padding-left: 75px;

hr{
  background-color: #484f57;
  margin-top: 10px;
  margin-bottom: 10px;
  opacity: 0.4;
}
.MuiTypography-subtitle1{
  font-family: Lato;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.22;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;
}
.MuiListItemIcon-root{
  min-width: 35px;
}
.MuiListItem-gutters{
  padding-left: 24px;
  padding-right: 24px;
}
  
@media (max-width: 600px){
  padding-left: 30px;
  padding-right: 30px;
  min-width: auto;
  width: 100vw;
  height: 100%;

  .MuiTypography-subtitle1{
    font-size: 16px;
  }

  .MuiListItem-gutters {
    padding-top: 7px;
    padding-bottom: 7px;
  }

  hr{
    margin-bottom: 5px;
  }
}
`;

const styles = theme => ({
  paper: props => props.paperTransparent ? {
    backgroundColor: 'transparent',
    border: 'none !important',
  } : null,
  closeIcon: {
    marginRight: theme.spacing(0.5)
  },
  headSection: {
    width: 200
  },
  blackList: {
    height: "100%",
    //backgroundImage: 'linear-gradient(to top, #000000 54%, rgba(0, 0, 0, 0) 98%)',
    backgroundColor: '#000000',
    opacity: 0.9,
  },
  noDecoration: {
    textDecoration: "none !important"
  }
});

class NavigationDrawer extends PureComponent {
  componentDidMount() {
    window.onresize = () => {
      const { width, open, onClose } = this.props;
      if (isWidthUp("sm", width) && open) {
        onClose();
      }
    };
  }

  render() {
    const {
      anchor,
      classes,
      open,
      onClose,
      menuItems,
      selectedItem,
      theme,
      isBright,
    } = this.props;
    return (
      <ClickAwayListener
        onClickAway={onClose}
        mouseEvent="onMouseDown"
      /* touchEvent="onTouchStart"  // this could be used on mobile? */
      >
        <Drawer variant="persistent" open={open} onClose={onClose} anchor={anchor} classes={{ paper: classes.paper }}>
          <Toolbar className={classes.headSection}>
            <ListItem
              style={{
                paddingTop: theme.spacing(0),
                paddingBottom: theme.spacing(0),
                height: "100%",
                justifyContent: anchor === "left" ? "flex-start" : "flex-end"
              }}
              disableGutters
            >
              <ListItemIcon className={classes.closeIcon}>
                <IconButton onClick={onClose} aria-label="Close Navigation" style={{ backgroundColor: 'transparent' }} disableRipple>
                  <CloseIcon color="primary" style={{ opacity: 0 }} />
                </IconButton>
              </ListItemIcon>
            </ListItem>
          </Toolbar>
          <StylesList className={classes.blackList} /* style={{ backgroundColor: !isBright ? '#000000' : '#FFFFFF', opacity: isBright ? 1 : 0.8 }} */>
            {menuItems.map((element, i) => {
              if (element.separator) {
                return <Divider key={i} variant="middle" />;
              }
              if (element.link) {
                return (
                  <Link
                    key={i}
                    to={element.link}
                    className={classes.noDecoration}
                    onClick={onClose}
                  >
                    <ListItem
                      button
                      selected={selectedItem === element.name}
                      /**
                       * We disable ripple as it will make a weird animation
                       * with primary and secondary color
                       */
                      disableRipple
                      disableTouchRipple
                    >
                      {element.icon && <ListItemIcon>{element.icon}</ListItemIcon>}
                      <ListItemText
                        primary={
                          <Typography variant="subtitle1" className="text-white">
                            {element.name}
                          </Typography>
                        }
                      />
                    </ListItem>
                  </Link>
                );
              }
              return (
                <ListItem button key={i} onClick={element.onClick}>
                  {element.icon && <ListItemIcon>{element.icon}</ListItemIcon>}
                  <ListItemText
                    primary={
                      <Typography variant="subtitle1" className="text-white">
                        {element.name}
                      </Typography>
                    }
                  />
                </ListItem>
              );
            })}
          </StylesList>
        </Drawer>
      </ClickAwayListener>
    );
  }
}

NavigationDrawer.propTypes = {
  anchor: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  menuItems: PropTypes.arrayOf(PropTypes.object).isRequired,
  classes: PropTypes.object.isRequired,
  width: PropTypes.string.isRequired,
  selectedItem: PropTypes.string
};

export default withWidth()(
  withStyles(styles, { withTheme: true })(NavigationDrawer)
);
